import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { usePlatformAuth } from "context/PlatformAuthContext";
import { PasswordInput } from "components/ui";

const PlatformLogin: React.FC = () => {
 const { t } = useTranslation();
 const [email, setEmail] = useState("");
 const [password, setPassword] = useState("");
 const [error, setError] = useState("");
 const [loading, setLoading] = useState(false);
 const { login, isAuthenticated } = usePlatformAuth();
 const navigate = useNavigate();

 React.useEffect(() => {
  if (isAuthenticated) {
   navigate("/platform/dashboard", { replace: true });
  }
 }, [isAuthenticated, navigate]);

 const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  setError("");
  setLoading(true);

  try {
   await login(email, password);
   navigate("/platform/dashboard");
  } catch (err: any) {
   setError(err.message || "Login failed. Please check your credentials.");
  } finally {
   setLoading(false);
  }
 };

 return (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
   <div className="max-w-md w-full space-y-8">
    <div>
     <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
      ushoplify
     </h2>
     <p className="mt-2 text-center text-sm text-gray-600">
      Sign in to manage stores and subscriptions
     </p>
    </div>
    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
     {error && (
      <div className="bg-red-50 border border-red-400 text-red-700 px-4 py-3 rounded">
       {error}
      </div>
     )}
     <div className=" -space-y-px">
      <div>
       <label htmlFor="email" className="sr-only">
        {t("common.placeholders.emailAddress")}
       </label>
       <input
        id="email"
        name="email"
        type="email"
        autoComplete="email"
        required
        className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
        placeholder={t("common.placeholders.emailAddress")}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
       />
      </div>
      <div>
       <PasswordInput
        id="password"
        name="password"
        autoComplete="current-password"
        required
        className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
        placeholder={t("common.placeholders.password")}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
       />
      </div>
     </div>

     <div>
      <button
       type="submit"
       disabled={loading}
       className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
      >
       {loading ? "Signing in..." : "Sign in"}
      </button>
     </div>
    </form>
   </div>
  </div>
 );
};

export default PlatformLogin;

